"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

var styles = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: '2rem'
  },
  img: {
    maxWidth: '100%',
    fontStyle: 'italic',
    verticalAlign: 'middle'
  },
  titles: {
    paddingLeft: '1rem',
    boxSizing: 'border-box'
  },
  heading: {
    margin: 0,
    fontWeight: 300,
    fontSize: '28px',
    color: '#fff'
  }
};

var ImpactLoginHeader = function ImpactLoginHeader(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: styles.header
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: require('../../../assets/img/logo.svg'),
    style: styles.img,
    alt: "McK/ID"
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: styles.titles
  }, /*#__PURE__*/_react.default.createElement("h1", {
    style: styles.heading
  }, "McKinsey ID"), /*#__PURE__*/_react.default.createElement("span", null, "By McKinsey")));
};

ImpactLoginHeader.propTypes = {
  children: _propTypes.default.any
};

var _default = (0, _radium.default)(ImpactLoginHeader);

exports.default = _default;